import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import whitlistData from './whitelist.json';
import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";

const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

  export const StyledButton = styled.button`
  border-radius: 5px;
  font-family: 'Luckiest Guy', 'cursive', sans-serif;
  border: none;
  background-color: var(--secondary);
  font-size: 30px;
  padding: 19px;
  font-weight: bold;
  color: var(--accent);
  width: 100%;
  cursor: pointer;
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 5px;
  font-family: sans-serif;
  border: none;
  background-color: transparent;
  padding: 10px;
  font-weight: 200;
  font-size: 50px;
  color: var(--secondary-text);
  width: 50px;
  height: 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: stretched;
  align-items: stretched;
  width: 100%;
  @media (min-width: 767px) {
    flex-direction: row;
  }
`;

export const StyledLogo = styled.img`
  width: 200px;
  @media (min-width: 767px) {
    width: 300px;
  }
  transition: width 0.5s;
  transition: height 0.5s;
`;

export const StyledImg = styled.img`
  width: 100%;
  max-width: 500px;
  transition: width 0.5s;
`;

export const StyledLink = styled.a`
  color: var(--accent-text);
  text-decoration: none;
`;

export const Ulist = styled.ul`
`;

export const List = styled.li`
`;

function App() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  const [feedback, setFeedback] = useState(`Cantidad`);
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
    WHITELIST: false,
  });

  const isWhitList = () => {
    let $isWhite = false
    whitlistData.map((item) => {
      if (blockchain.account.toLowerCase() == item.wallet.toLowerCase()){
        $isWhite = true
      }
    });
  
    return $isWhite;
  };

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let price = CONFIG.DISPLAY_COST;
    let total = String(price * mintAmount);
    let totalCostWei = String(cost * mintAmount);
    let totalGasLimit = String(gasLimit + 5000 * mintAmount);
    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .PublicMint(mintAmount, blockchain.account)
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("./config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <s.Screen
    style={{ backgroundColor: "#43c7ec" }}
    image={CONFIG.SHOW_BACKGROUND ? "./config/images/bg.png" : null}
    >
      <s.Container
      className="header"
      style={{ padding: 24, display: "flex", flexDirection: "row", alignItems: "center", borderBottom: "4px solid #000" }}
      >
        <s.Container
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
          <StyledImg 
                style={{
                  textAlign: "center",
                  maxWidth: "40px",
                  marginRight: "1rem"
                }} 
                alt={"logo"} src={"./config/images/logo.png"} />
        </s.Container>
        {/* <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 30,
                color: "var(--accent-text)",
                textTransform: "uppercase",
                flex: 1,
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              {CONFIG.NFT_NAME}
        </s.TextTitle> */}
        <s.Container
              className="nav-menu"
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                textTransform: "uppercase",
                flex: 3,
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
              }}
            >
              <StyledLink className="social-link" target={"_blank"} href="https://nft.tecatepalnorte.com/#beneficios">Beneficios</StyledLink>
              <StyledLink className="social-link" target={"_blank"} href="https://nft.tecatepalnorte.com/#roadmap">Roadmap</StyledLink>
              <StyledLink className="social-link" target={"_blank"} href="https://nft.tecatepalnorte.com/#preguntas-frecuentes">Preguntas Frecuentes</StyledLink>
              <StyledLink className="social-link" target={"_blank"} href="https://legendary.tecatepalnorte.com/">Legendary Lions</StyledLink>
        </s.Container>
        <s.Container
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                textTransform: "uppercase",
                flex: 1,
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
              }}
            >
              {/* <StyledLink className="social-link" target={"_blank"} href="https://twitter.com/cervezaindio"><i class="fab fa-twitter"></i></StyledLink>
              <StyledLink className="social-link" target={"_blank"} href="https://www.facebook.com/cervezaindio/"><i class="fab fa-facebook"></i></StyledLink> */}
              <StyledLink className="social-link" target={"_blank"} href="https://discord.gg/tecatepalnorte"><i class="fab fa-discord"></i></StyledLink>
              {/* <StyledLink className="social-link" target={"_blank"} href="https://www.cervezaindionft.com/"><i class="fa fa-globe"></i></StyledLink> */}
        </s.Container>

      </s.Container>
      <s.Container
        flex={1}
        ai={"center"}
      >
        <s.SpacerSmall />
        
        <ResponsiveWrapper flex={1} style={{ padding: 24, maxWidth: 1200 }} test>
          <s.Container
            flex={1}
            jc={"center"}
            ai={"center"}
            style={{
              padding: 24,
              borderRadius: 25,
            }}
            >
            <s.TextTitle
              style={{
                textAlign: "center",
                fontSize: 60,
                letterSpacing: "0.5rem",
                fontWeight: "bold",
                color: "var(--accent-text)",
                textTransform: "uppercase",
              }}
              >
              {CONFIG.NFT_NAME}
            </s.TextTitle>
            <s.Container
              flex={1}
              jc={"center"}
              ai={"center"}
              fd={"row"}
              style={{maxHeight: "100px"}}
            >
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                fontSize: 20,
                fontWeight: 300,
              }}>
                Cada León
            </s.TextDescription>
            <s.SpacerMedium />
            <s.SpacerMedium />
            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                fontSize: 20,
                fontWeight: 300,
              }}>
                $2,000 mxn
            </s.TextDescription>
            </s.Container>

            <s.TextDescription
              style={{
                textAlign: "center",
                color: "var(--accent-text)",
                fontWeight: 600,
              }}>
                Selecciona tu opción de compra y sigue los pasos que aparecerán a continuación 
            </s.TextDescription>
            {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <>
                  <s.TextDescription
                    style={{
                      textAlign: "center",
                      color: "var(--primary-text)",
                    }}
                  ></s.TextDescription>
                  </>
                ) : (
                  <>
                  <s.TextTitle
                    style={{
                      textAlign: "center",
                      fontSize: 50,
                      fontWeight: "bold",
                      color: "var(--accent-text)",
                    }}
                  >
                    {data.totalSupply} / {CONFIG.MAX_SUPPLY}
                  </s.TextTitle>
                  {/* <s.TextDescription
                    style={{
                      textAlign: "center",
                      color: "var(--primary-text)",
                    }}>
                
                    <StyledLink target={"_blank"} href={CONFIG.SCAN_LINK}>
                      {truncate(CONFIG.CONTRACT_ADDRESS, 15)}
                    </StyledLink>
                  </s.TextDescription> */}
                  </>
                )}
            <s.SpacerSmall />
            {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
              <>
                <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  The sale has ended.
                </s.TextTitle>
                <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  You can still find {CONFIG.NFT_NAME} on
                </s.TextDescription>
                <s.SpacerSmall />
                <StyledLink target={"_blank"} href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </StyledLink>
              </>
            ) : (
              <>
                {/* <s.TextTitle
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  1 {CONFIG.SYMBOL} = {CONFIG.DISPLAY_COST}{" "}
                  {CONFIG.NETWORK.SYMBOL} + GAS.
                </s.TextTitle> */}
                <s.SpacerXSmall />
                {/* <s.TextDescription
                  style={{ textAlign: "center", color: "var(--accent-text)" }}
                >
                  Excluding gas fees.
                </s.TextDescription> */}
                <s.SpacerSmall />
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <s.Container ai={"center"} jc={"center"}>
                    <CrossmintPayButton
                          className="xmint-btn xmint-btn1"
                          clientId="e93d6ad1-c185-45dc-91bd-6083303e1b27"
                          mintConfig={{"type":"erc-721","totalPrice":"0.065","_mintAmount":"1"}}
                      />
                      <s.SpacerSmall />
                      <CrossmintPayButton
                          className="xmint-btn xmint-btn2"
                          clientId="e93d6ad1-c185-45dc-91bd-6083303e1b27"
                          mintConfig={{"type":"erc-721","totalPrice":"0.13","_mintAmount":"2"}}
                      />
                      <s.SpacerSmall />
                      <CrossmintPayButton
                          className="xmint-btn xmint-btn3"
                          clientId="e93d6ad1-c185-45dc-91bd-6083303e1b27"
                          mintConfig={{"type":"erc-721","totalPrice":"0.195","_mintAmount":"3"}}
                      />
                      <s.SpacerSmall />
                    {/* <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      Connect to the {CONFIG.NETWORK.NAME} network
                    </s.TextDescription> */}
                    <s.SpacerSmall />
                    <StyledButton
                      className="learn-more"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      Comprar con Ethereum
                    </StyledButton>
                      <s.SpacerSmall />
                      
                    {blockchain.errorMsg !== "" ? (
                      <>
                        <s.SpacerSmall />
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                          }}
                        >
                          {blockchain.errorMsg}
                        </s.TextDescription>
                      </>
                    ) : null}
                  </s.Container>
                ) : (
                  <>
                    <s.TextDescription
                      style={{
                        textAlign: "center",
                        color: "var(--accent-text)",
                      }}
                    >
                      {feedback}
                    </s.TextDescription>
                    <s.SpacerMedium />
                    <s.Container ai={"center"} jc={"center"} fd={"row"} className="qty">
                      <s.Container flex={1} ai={"center"} jc={"flex-start"} fd={"row"} style={{borderRight: "2px solid #000"}}>
                      <s.SpacerMedium />
                        <StyledRoundButton
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            decrementMintAmount();
                          }}
                        >
                          -
                        </StyledRoundButton>
                        <s.SpacerMedium />
                        <s.SpacerMedium />
                        <s.TextSubTitle
                          style={{
                            textAlign: "center",
                            color: "var(--secondary-text)",
                            fontSize: "35px"
                          }}
                        >
                          {mintAmount}
                        </s.TextSubTitle>
                        <s.SpacerMedium />
                        <s.SpacerMedium />
                        <StyledRoundButton
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            incrementMintAmount();
                          }}
                        >
                          +
                        </StyledRoundButton>
                        <s.SpacerMedium />
                      </s.Container>
                      <s.Container flex={1} ai={"center"} jc={"center"} fd={"row"}>
                        <s.TextSubTitle
                            style={{
                              textAlign: "center",
                              color: "var(--secondary-text)",
                              fontSize: "30px"
                            }}
                          >
                            Total: 
                        </s.TextSubTitle>
                        <s.SpacerMedium />
                        <s.TextSubTitle
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                            fontSize: "30px"
                          }}
                        >
                          {parseFloat((CONFIG.DISPLAY_COST * mintAmount).toFixed(3))}
                        </s.TextSubTitle>
                        
                      </s.Container>
                    </s.Container>
                    <s.SpacerSmall />
                    <s.Container ai={"center"} jc={"center"} fd={"column"}>
                    {(isWhitList() || CONFIG.WHITELIST == false ? (
                      <>
                      <StyledButton
                        className="learn-more"
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "Comprar" : "Comprar"}
                      </StyledButton>
                      </>
                      ) : (
                        <s.TextDescription
                          style={{
                            textAlign: "center",
                            color: "var(--accent-text)",
                            fontSize: "25px",
                          }}
                        >
                          You are not whitelisted
                        </s.TextDescription>)
                      )}
                    </s.Container>
                  </>
                )}
              </>
            )}
            
            <s.SpacerMedium />
          </s.Container>
          <s.SpacerLarge />
          <s.Container flex={1} jc={"center"} ai={"center"}>
            <StyledImg style={{ borderRadius: 25 }} alt={"example"} src={"./config/images/nft.png"} />
          </s.Container>
        </ResponsiveWrapper>
        </s.Container>
        {/* <s.Container jc={"center"} ai={"center"} style={{ padding: 24, borderTop: "1px solid #fff", }}>
          <s.TextDescription
            style={{
              textAlign: "center",
              color: "var(--accent-text)",
            }}
          >
            {CONFIG.NFT_NAME}® 2022
          </s.TextDescription>
        </s.Container> */}
    </s.Screen>
  );
}

export default App;
